/**
 * plugins/index.ts
 *
 * Automatically included in `./src/main.ts`
 */
import "@mdi/font/css/materialdesignicons.css"; // Ensure you are using css-loader
// Plugins
import { loadFonts } from "./webfontloader";
import vuetify from "./vuetify";

// Types
import type { App } from "vue";

import { createVuetify } from "vuetify";
import { aliases, mdi } from "vuetify/iconsets/mdi-svg";

export default createVuetify({
  icons: {
    defaultSet: "mdi", // This is already the default value - only for display purposes
    aliases,
    sets: { mdi },
  },
});

export function registerPlugins(app: App) {
  loadFonts();
  app.use(vuetify);
}
